import { endOfMonth, endOfWeek, format, parse, startOfMonth, startOfWeek } from "date-fns";

/** Convert a snapshot period start date into inclusive start/end YYYY-MM-DD bounds. */
export function periodToDateRange(
  periodType: "monthly" | "weekly",
  date: string
): { startDate: string; endDate: string } {
  const periodDate = parse(date.slice(0, 10), "yyyy-MM-dd", new Date());
  if (periodType === "monthly") {
    return {
      startDate: format(startOfMonth(periodDate), "yyyy-MM-dd"),
      endDate: format(endOfMonth(periodDate), "yyyy-MM-dd"),
    };
  }
  return {
    startDate: format(startOfWeek(periodDate, { weekStartsOn: 1 }), "yyyy-MM-dd"),
    endDate: format(endOfWeek(periodDate, { weekStartsOn: 1 }), "yyyy-MM-dd"),
  };
}
